<template>
  <div id="divSummary">
    <div class="Flex_Table tblEntryForm">
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <fieldset style="width: 100% !important">
            <legend>
              <div>
                <input
                  type="radio"
                  name="rbFilter"
                  id="rbNewUser"
                  value="1"
                  v-model="rbFilter"
                  v-on:click="changeFilters(1)"
                />
                <label for="rbNewUser">Create New User</label>
                <input
                  type="radio"
                  name="rbFilter"
                  id="rbViewUser"
                  value="2"
                  v-model="rbFilter"
                  v-on:click="changeFilters(2)"
                />
                <label for="rbViewUser">View User</label>
              </div>
            </legend>
            <div
              class="Flex_Row GridContent"
              style="overflow-y: scroll; height: calc(80vh - 110px)"
            >
              <div class="Flex_Cell">
                <div class="Flex_Table tblEntryForm">
                  <div class="Flex_Row">
                    <div class="Flex_Cell_Inline">
                      <span class="mandatorySpan" :class="{ Required: false }">User Type &nbsp;</span>
                      <select id="ddlUserType" v-model="userType" @change="getUserList()">
                        <option value="-1">---Select---</option>
                        <option
                          v-for="u in userType_List"
                          :key="u[0]"
                          v-bind:value="u[0]"
                        >{{ u[1] }}</option>
                      </select>
                    </div>
                    <div class="Flex_Cell_Inline" v-if="userType != -1 && rbFilter == 2">
                      <span class="mandatorySpan" :class="{ Required: false }">
                        <span>
                          <input
                            type="checkbox"
                            v-model="isDeleted"
                            :id="'isDeleted'"
                            @change="getUserList()"
                          />
                          <label :for="'isDeleted'">Active User</label>
                        </span>
                      </span>
                      <select id="ddlUserType" v-model="userID" @change="getUserProfile()">
                        <option value="-1">---Select---</option>
                        <option
                          v-for="u in user_List"
                          :key="u.userID"
                          v-bind:value="u.userID"
                        >{{ u.userName }}</option>
                      </select>
                    </div>
                  </div>
                  <fieldset
                    style="width: 100% !important"
                    v-if="rbFilter == 1 || (rbFilter == 2 && userID != -1)"
                  >
                    <legend>User Profile</legend>
                    <div class="Flex_Table">
                      <div class="Flex_Row" v-if="rbFilter == 1 || (rbFilter == 2 && userID != -1)">
                        <div class="Flex_Cell" style="width: 20%">
                          <table style="width: 100%">
                            <tr>
                              <td style="max-width: 20% !important">
                                <span
                                  class="mandatorySpan"
                                  :class="{ Required: true }"
                                  v-if="rbFilter == 1"
                                >Title &nbsp;</span>
                                <span class="mandatorySpan" v-else>Title &nbsp;</span>
                                <select id="ddlTitle" v-model="title">
                                  <option value="-1">---Select---</option>
                                  <option
                                    v-for="t in title_List"
                                    :key="t[0]"
                                    v-bind:value="t[0]"
                                  >{{ t[1] }}</option>
                                </select>
                              </td>
                              <td style="max-width: 5% !important">&nbsp;</td>
                              <td style="max-width: 75% !important">
                                <span
                                  class="mandatorySpan"
                                  :class="{ Required: true }"
                                  v-if="rbFilter == 1"
                                >First Name &nbsp;</span>
                                <span class="mandatorySpan" v-else>First Name &nbsp;</span>
                                <AcceptInput
                                  maxlength="50"
                                  ref="fName"
                                  type="textbox"
                                  :isRequired="true"
                                  placeholder="PLEASE ENTER FIRST NAME"
                                  v-model="fName"
                                  class="CreateAccount"
                                  regExp="([A-Z a-z()])*"
                                />
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span class="mandatorySpan">Middle Name</span>
                          <AcceptInput
                            maxlength="50"
                            ref="mName"
                            type="textbox"
                            placeholder="PLEASE ENTER MIDDLE NAME"
                            v-model="mName"
                            class="CreateAccount"
                            regExp="([A-Z a-z()])*"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            v-if="rbFilter == 1"
                          >Last Name &nbsp;</span>
                          <span class="mandatorySpan" v-else>Last Name &nbsp;</span>
                          <AcceptInput
                            maxlength="50"
                            ref="lName"
                            type="textbox"
                            :isRequired="true"
                            placeholder="PLEASE ENTER LAST NAME"
                            v-model="lName"
                            class="CreateAccount"
                            regExp="([A-Z ()a-z])*"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            v-if="rbFilter == 1"
                          >User Mobile Number &nbsp;</span>
                          <span class="mandatorySpan" v-else>User Mobile Number &nbsp;</span>
                          <AcceptInput
                            maxlength="10"
                            ref="userMobile"
                            type="textbox"
                            :isRequired="true"
                            placeholder="PLEASE ENTER MOBILE NUMBER"
                            v-model="userMobile"
                            class="CreateAccount"
                            regExp="([0-9])*"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            v-if="rbFilter == 1"
                          >User Email &nbsp;</span>
                          <span class="mandatorySpan" v-else>User Email &nbsp;</span>
                          <AcceptInput
                            maxlength="100"
                            ref="userEmail"
                            type="email"
                            :isRequired="true"
                            placeholder="PLEASE ENTER EMAIL"
                            v-model="userEmail"
                            class="CreateAccount"
                          />
                        </div>
                      </div>
                      <div class="Flex_Row" v-if="rbFilter == 1 || (rbFilter == 2 && userID != -1)">
                        <div class="Flex_Cell" style="width: 20%">
                          <span class="mandatorySpan">Date of Birth</span>
                          <DateControl
                            :isRequired="true"
                            style="max-width: 295px !important"
                            v-model="dob"
                          ></DateControl>
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            v-if="rbFilter == 1"
                          >Gender &nbsp;</span>
                          <span class="mandatorySpan" v-else>Gender &nbsp;</span>
                          <div valign="bottom" v-for="g in gender_List" :key="g[2]" class="rblDiv">
                            <input
                              ref="gender"
                              name="rblGender"
                              class="rblgender"
                              type="radio"
                              v-model="gender"
                              :value="g[2]"
                            />
                            &nbsp;{{ g[1] }}
                          </div>
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span class="mandatorySpan">Full Address</span>
                          <textarea
                            ref="fullAdd"
                            v-model="fullAdd"
                            placeholder="ENTER FULL ADDRESS"
                            title="ENTER FULL ADDRESS"
                            maxlength="500"
                            v-on:keypress="validateAddress($event)"
                            @click.right.prevent
                            @copy.prevent
                            @paste.prevent
                            regExp="([A-Z ' ,-/&@*()'a-z])*"
                          ></textarea>
                        </div>
                        <div class="Flex_Cell" style="width: 20%" v-if="rbFilter == 1">
                          <span class="mandatorySpan" :class="{ Required: true }">New Password</span>
                          <AcceptInput
                            maxlength="112"
                            ref="userPass"
                            type="password"
                            :isRequired="true"
                            placeholder="PLEASE ENTER YOUR NEW PASSWORD"
                            v-model="userPass"
                            class="CreateAccount"
                            @keyup="checkPasswordStrength($event)"
                            autocomplete="off"
                            readonly
                            onfocus="this.removeAttribute('readonly');"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 20%" v-if="rbFilter == 1">
                          <span class="mandatorySpan" :class="{ Required: true }">Confirm Password</span>
                          <AcceptInput
                            maxlength="112"
                            ref="confirmPass"
                            type="password"
                            :isRequired="true"
                            placeholder="PLEASE CONFIRM YOUR PASSWORD"
                            v-model="confirmPass"
                            class="CreateAccount"
                            autocomplete="off"
                            @keyup="confirmPassword($event)"
                            readonly
                            onfocus="this.removeAttribute('readonly');"
                          />
                        </div>
                        <div class="Flex_Cell" valign="middle" v-if="rbFilter == 2">
                          <span v-if="isUserAuthenticated == 1" style="color: Orange">
                            <span v-if="userType == 3 || userType == 4"></span>
                            <span v-else>
                              <i class="DataIcon glyphicons circle_exclamation_mark"></i>&nbsp;
                              <b>
                                <span>Required documents pending.</span>
                              </b>
                            </span>
                          </span>
                          <span v-if="isUserAuthenticated == 2" style="color: Green">
                            <i class="DataIcon glyphicons ok"></i>&nbsp;
                            <b>Approved.</b>
                          </span>
                          <span v-if="isUserAuthenticated == 0" style="color: Red">
                            <i class="DataIcon glyphicons remove"></i>&nbsp;
                            <b>Disapproved.</b>
                          </span>
                        </div>
                      </div>
                      <div
                        class="Flex_Row"
                        v-if="
                          rbFilter == 2 &&
                          userID != -1 &&
                          (userType == 2 || userType == 5)
                        "
                      >
                        <div class="Flex_Cell" style="width: 20%">
                          <span class="mandatorySpan">Company Name</span>
                          <AcceptInput
                            maxlength="112"
                            ref="CompanyName"
                            type="text"
                            placeholder="PLEASE ENTER NAME"
                            v-model="companyName"
                            class="CreateAccount"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span class="mandatorySpan">Company Website</span>
                          <AcceptInput
                            maxlength="112"
                            ref="CompanyWebsite"
                            type="text"
                            placeholder="PLEASE ENTER WEBSITE"
                            v-model="companyWebsite"
                            class="CreateAccount"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span class="mandatorySpan">Company Contact</span>
                          <AcceptInput
                            maxlength="112"
                            ref="CompanyContact"
                            type="text"
                            placeholder="PLEASE ENTER CONTACT NUMBER"
                            v-model="companyContact"
                            class="CreateAccount"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span class="mandatorySpan">Company Email</span>
                          <AcceptInput
                            maxlength="112"
                            ref="CompanyEmail"
                            type="text"
                            placeholder="PLEASE ENTER EMAIL"
                            v-model="companyEmail"
                            class="CreateAccount"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span class="mandatorySpan">Comment</span>
                          <textarea
                            ref="CompanyComment"
                            v-model="companyComment"
                            placeholder="PLEASE ENTER COMMENT"
                            title="PLEASE ENTER COMMENT"
                            maxlength="500"
                          ></textarea>
                        </div>
                      </div>
                      <div
                        class="Flex_Row"
                        v-if="
                          rbFilter == 2 &&
                          userID != -1 &&
                          (userType == 2 || userType == 5)
                        "
                      >
                        <div class="Flex_Table ekkGrid" align="center">
                          <div class="Flex_Row GridHeader" valign="middle" style="min-height: 40px">
                            <div class="Flex_Cell" style="width: 33%">
                              <span>Document Type</span>
                            </div>
                            <div class="Flex_Cell" style="width: 33%">
                              <span>Document Number</span>
                            </div>
                            <div class="Flex_Cell" style="width: 34%">
                              <span>Uploaded File</span>
                            </div>
                          </div>
                          <div
                            class="Flex_Row GridContent"
                            v-for="i in idType_List"
                            :key="i.idType"
                            valign="middle"
                          >
                            <div class="Flex_Cell" style="width: 33%">
                              <span>{{ i.idTypeName }}</span>
                            </div>
                            <div class="Flex_Cell" style="width: 33%">
                              <span>{{ i.idNumber }}</span>
                            </div>
                            <div class="Flex_Cell" style="width: 34%">
                              <a @click="openScanImage(i)" v-if="i.idImageFileExtension != 'pdf'">
                                <span>{{ i.idImageFileName }}</span>
                              </a>
                              <a
                                v-else
                                download
                                :href="
                                  'data:application/pdf;base64,' + i.idImageFile
                                "
                              >
                                <span>{{ i.idImageFileName }}</span>
                              </a>
                              <!-- <img
                            v-if="i.idImageFile != null || i.idImageFile != ''"
                            :src="
                              'data:image/jpeg;base64,'.concat(i.idImageFile)
                            "
                            style="height: 50px; width: 50px"
                              />-->
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="Flex_Row" v-if="rbFilter == 2">
                        <div class="Flex_Cell" align="center" v-if="userProfile_List.length > 0">
                          <input
                            type="button"
                            v-if="ActiveStatus == 1"
                            style="background-color: Green; padding: 10px"
                            value="Activate User"
                            @click="ClickForActiveInactive(8)"
                          />
                          <input
                            type="button"
                            v-if="ActiveStatus == 0"
                            style="background-color: red; padding: 10px"
                            value="Inactivate User"
                            @click="ClickForActiveInactive(7)"
                          />
                        </div>
                      </div>
                      <div class="Flex_Row" align="center" valign="middle" v-if="rbFilter == 1">
                        <div class="Flex_Cell">
                          <input
                            type="button"
                            v-model="saveProfile"
                            style="padding: 10px"
                            title="Click to Save Profile"
                            @click="createNewUser()"
                          />
                          <input
                            type="button"
                            v-model="clear"
                            style="padding: 10px"
                            title="Click to Clear Profile"
                            @click="clearProfile()"
                          />
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <br />
                  <fieldset
                    style="width: 100% !important"
                    v-if="
                      rbFilter == 2 &&
                      userID != -1 &&
                      (userType == 2 || userType == 5)
                    "
                  >
                    <legend>Admin Action</legend>
                    <div class="Flex_Table">
                      <div class="Flex_Row" style="display: none">
                        <div class="Flex_Cell">
                          <div class="Flex_Table">
                            <div class="Flex_Row">
                              <div class="Flex_Cell">
                                <span
                                  class="mandatorySpan"
                                  :class="{ Required: true }"
                                >Entry Type &nbsp;</span>
                                <select id="ddlTitle" v-model="entryTypeID">
                                  <!-- <option value="-1">---Select---</option> -->
                                  <option
                                    v-for="e in entryType_List"
                                    :key="e[0]"
                                    v-bind:value="e[0]"
                                  >{{ e[1] }}</option>
                                </select>
                              </div>
                              <div class="Flex_Cell">
                                <span class="mandatorySpan">From Date</span>
                                <DateControl
                                  :isRequired="true"
                                  style="max-width: 275px !important"
                                  v-model="fromDate"
                                ></DateControl>
                              </div>
                              <div class="Flex_Cell">
                                <span class="mandatorySpan">To Date</span>
                                <DateControl
                                  :isRequired="true"
                                  style="max-width: 275px !important"
                                  v-model="toDate"
                                ></DateControl>
                              </div>
                              <div class="Flex_Cell">
                                <span
                                  class="mandatorySpan"
                                  :class="{ Required: true }"
                                >Reason &nbsp;</span>
                                <textarea
                                  title="REASON"
                                  placeholder="REASON"
                                  v-model="reason"
                                  maxlength="500"
                                ></textarea>
                              </div>
                              <div class="Flex_Cell">
                                <span class="mandatorySpan">Comment(s) (if any)</span>
                                <textarea
                                  title="PLEASE ENTER COMMENT IF ANY"
                                  placeholder="PLEASE ENTER COMMENT IF ANY"
                                  v-model="comment"
                                  maxlength="500"
                                ></textarea>
                              </div>
                              <div class="Flex_Cell">
                                <span class="mandatorySpan">Active Status</span>
                                <select id="ddlTitle" v-model="activeStatusID">
                                  <option value="-1">---Select---</option>
                                  <option
                                    v-for="a in activeStatus_List"
                                    :key="a.activeStatus"
                                    v-bind:value="a.activeStatus"
                                  >{{ a.activeStatusName }}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="Flex_Row">
                        <div class="Flex_Cell docGrid">
                          <div class="Flex_Table ekkGrid">
                            <div
                              class="Flex_Row GridHeader"
                              align="center"
                              valign="middle"
                              style="min-height: 40px"
                            >
                              <div class="Flex_Cell" width="33%">
                                <span class="mandatorySpan">
                                  Document
                                  <br />
                                  <span style="color: Yellow">
                                    (File must be in .jpg /.jpeg /.png /.pdf
                                    format and size between 10 to 50 kb
                                    only)
                                  </span>
                                </span>
                              </div>
                              <div class="Flex_Cell" width="33%">
                                <span class="mandatorySpan">Purpose &nbsp;</span>
                              </div>
                              <div class="Flex_Cell" width="34%">Add / Delete</div>
                            </div>
                            <div
                              class="Flex_Row GridContent"
                              align="center"
                              valign="middle"
                              style="min-height: 50px !important"
                            >
                              <div class="Flex_Cell" width="33%">
                                <input type="file" id="FileBox" v-on:change="FileChosen($event)" />
                              </div>
                              <div class="Flex_Cell" width="33%">
                                <textarea
                                  title="PLEASE ENTER PURPOSE"
                                  placeholder="PLEASE ENTER PURPOSE"
                                  v-model="purpose"
                                ></textarea>
                              </div>
                              <div class="Flex_Cell" width="34%">
                                <input
                                  type="button"
                                  style="padding: 5px"
                                  v-model="add_update"
                                  @click="addDocAuth()"
                                />
                              </div>
                            </div>
                            <div
                              class="Flex_Row GridContent"
                              align="center"
                              valign="middle"
                              v-for="(row, index) in docAuth_List"
                              :key="index"
                              style="min-height: 30px"
                            >
                              <div class="Flex_Cell" width="33%">{{ row.DocumentFileName }}</div>
                              <div class="Flex_Cell" width="33%">{{ row.PurposeExplanation }}</div>
                              <div class="Flex_Cell" width="34%">
                                <!-- <span
                                  class="glyphicons pen"
                                  v-on:click="editDocAuth(row)"
                                  style="cursor: pointer"
                                  title="Edit"
                                ></span>-->
                                <span
                                  class="glyphicons bin"
                                  v-on:click="removedocAuth(index)"
                                  style="cursor: pointer"
                                  title="Delete"
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="Flex_Row" align="center">
                        <div class="Flex_Cell">
                          <input
                            type="button"
                            v-model="btnSaveUpdateAuth"
                            style="padding: 10px"
                            @click="saveAgentAuthentication()"
                          />
                          <input
                            type="button"
                            value="Clear"
                            style="padding: 10px"
                            @click="clearAgentAuthentication()"
                          />
                        </div>
                      </div>
                      <div class="Flex_Row" style="display: none">
                        <div class="Flex_Cell docGrid">
                          <div class="Flex_Table ekkGrid" v-if="authDataList1.length > 0">
                            <div
                              class="Flex_Row GridHeader"
                              align="center"
                              valign="middle"
                              style="min-height: 40px"
                            >
                              <div class="Flex_Cell" width="5%">Sr. No.</div>
                              <div class="Flex_Cell" width="10%">Entry Type Name</div>
                              <div class="Flex_Cell" width="10%">Valid From</div>
                              <div class="Flex_Cell" width="10%">Valid Upto</div>
                              <div class="Flex_Cell" width="20%">Comments</div>
                              <div class="Flex_Cell" width="20%">Remarks</div>
                              <div class="Flex_Cell" width="20%">Document List</div>
                              <div class="Flex_Cell" width="5%">Edit / Delete</div>
                            </div>
                            <div
                              class="Flex_Row GridContent"
                              align="center"
                              valign="middle"
                              v-for="(row, index) in authDataList1"
                              :key="index"
                            >
                              <div class="Flex_Cell" width="5%">{{ index + 1 }}</div>
                              <div class="Flex_Cell" width="10%">{{ row.entryTypeName }}</div>
                              <div class="Flex_Cell" width="10%">{{ row.validDateFrom }}</div>
                              <div class="Flex_Cell" width="10%">{{ row.validDateTo }}</div>
                              <div class="Flex_Cell" width="20%">{{ row.comments }}</div>
                              <div class="Flex_Cell" width="20%">{{ row.otherRemarks }}</div>
                              <div class="Flex_Cell" width="20%">
                                <div class="Flex_Table ekkGrid">
                                  <div
                                    class="Flex_Row GridHeader"
                                    align="center"
                                    valign="middle"
                                    style="min-height: 30px"
                                  >
                                    <div class="Flex_Cell" width="20%">Document</div>
                                    <div class="Flex_Cell" width="20%">Purpose</div>
                                  </div>
                                  <div
                                    class="Flex_Row GridContent"
                                    align="center"
                                    valign="middle"
                                    v-for="(
                                      row1, index1
                                    ) in authDataList2.filter((r) => {
                                      return (
                                        r.userAuthenticationID ==
                                        row.userAuthenticationID
                                      );
                                    })"
                                    :key="index1"
                                    style="min-height: 30px"
                                  >
                                    <div
                                      class="Flex_Cell"
                                      width="20%"
                                      v-if="
                                        row.userAuthenticationID ==
                                        row1.userAuthenticationID
                                      "
                                    >
                                      <a
                                        v-if="
                                          row1.documentFileExtension != 'pdf'
                                        "
                                        @click="openUploadedFile(row1)"
                                      >{{ row1.documentFileName }}</a>
                                      <a
                                        v-else
                                        download
                                        :href="
                                          'data:application/pdf;base64,' +
                                          i.idImageFile
                                        "
                                      >{{ row1.documentFileName }}</a>
                                    </div>
                                    <div
                                      class="Flex_Cell"
                                      width="20%"
                                      v-if="
                                        row.userAuthenticationID ==
                                        row1.userAuthenticationID
                                      "
                                    >{{ row1.purposeExplanation }}</div>
                                  </div>
                                </div>
                              </div>
                              <div class="Flex_Cell" width="5%">
                                <span
                                  class="glyphicons pen"
                                  v-on:click="editAuthData(row)"
                                  style="cursor: pointer"
                                  title="Edit"
                                ></span>
                                <span
                                  class="glyphicons bin"
                                  v-on:click="deleteAuthData(row)"
                                  style="cursor: pointer; color: Red"
                                  title="Delete"
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" align="center" v-if="isUserAuthenticated != 1">
                <input
                  type="button"
                  v-if="isUserAuthenticated == 0"
                  style="background-color: Green; padding: 10px"
                  value="Approve"
                  @click="ClickForApproval(1)"
                />
                <input
                  type="button"
                  v-if="isUserAuthenticated == 2"
                  style="background-color: Red; padding: 10px"
                  value="Disapprove"
                  @click="ClickForApproval(2)"
                />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";
import MasterEntryJS from "./servicesJS/MasterEntry.js";
import MasterJS from "./servicesJS/Master.js";
import UserManagementJS from "./servicesJS/UserManagement.js";
import UserProfile from "./servicesJS/UserProfile.js";
import biometricJS from "../router/biometric";

export default {
  name: "UserManagement",
  components: {
    DateControl: DateControl,
    AcceptInput: AcceptInput
  },
  data() {
    return {
      rbFilter: "1",
      userType_List: [],
      user_List: [],
      userProfile_List: [],
      title_List: [],
      gender_List: [],
      idType_List: [],
      idType: 0,
      title: -1,
      userType: -1,
      gender: 0,
      userID: -1,
      fName: "",
      mName: "",
      lName: "",
      dob: new Date("01 Jan 1900"),
      userMobile: "",
      mob: "",
      userEmail: "",
      email: "",
      fullAdd: "",
      userPass: "",
      confirmPass: "",
      saveProfile: "Save",
      clear: "Clear",
      companyName: "",
      companyWebsite: "",
      companyContact: "",
      companyEmail: "",
      companyComment: "",

      isPasswordStrenth: false,
      entryType_List: [],
      entryTypeID: 1,
      fromDate: new Date("01 Jan 1900"),
      toDate: new Date("01 Jan 1900"),
      activeStatus_List: [],
      activeStatusID: 1,
      reason: "",
      comment: "",
      docAuth_List: [],
      uploadedFile: [],
      purpose: "",
      fromDateForApproval: new Date("01 Jan 1900"),
      toDateForApproval: new Date("01 Jan 1900"),
      btnSaveUpdateAuth: "Save Authentication",
      UserAuthenticationID: -1,

      authDataList1: [],
      authDataList2: [],
      add_update: "Add",
      isDeleted: true,
      isDeletedint: 0,
      ActiveStatus: "",
      userMessage: "",
      isUserAuthenticated: 1
    };
  },
  methods: {
    validateInput(type) {
      if (type == 1) {
        if (this.fName == null || this.fName == "") {
          alert("Please enter your first name");
          this.$refs.fName.focus();
          return false;
        }
        if (this.lName == null || this.lName == "") {
          alert("Please enter your last name");
          this.$refs.lName.focus();
          return false;
        }
        // if (
        //   this.dob == null ||
        //   this.dob == "" ||
        //   this.dob.convertToString("dd MMM yyyy") ==
        //     new Date("01 Jan 1900").convertToString("dd MMM yyyy")
        // ) {
        //   alert("Please enter your date of birth");
        //   this.$refs.dob.focus();
        //   return false;
        // }
        if (this.dob > new Date()) {
          alert("Please enter your valid date of birth");
          this.$refs.dob.focus();
          return false;
        }

        // if (
        //   this.dob < this.dOBCheckList.minDate.toDateTime() ||
        //   this.dob > this.dOBCheckList.maxDate.toDateTime()
        // ) {
        //   alert("Date of birth is not greater or less than of min or max date");
        //   return false;
        // }
        if (this.userMobile == null || this.userMobile == "") {
          alert("Please enter your mobile number");
          this.$refs.userMobile.focus();
          return false;
        }
        if (this.userMobile.startsWith("0")) {
          alert("Mobile number cannot start with 0");
          this.$refs.userMobile.focus();
          return false;
        }
        if (this.userMobile.length != "10") {
          alert("Mobile number must be 10 digits");
          this.$refs.userMobile.focus();
          return false;
        }

        if (this.userEmail == null || this.userEmail == "") {
          alert("Please enter your valid email");
          this.$refs.userEmail.focus();
          return false;
        }
        if (!this.$refs.userEmail.isValid) {
          alert("Email format is not valid");
          this.$refs.userEmail.focus();
          return false;
        }
        if (this.userPass == null || this.userPass == "") {
          alert("Please enter your password");
          this.$refs.userPassword.focus();
          return false;
        }
        if (this.confirmPass == null || this.confirmPass == "") {
          alert("Please confirm your password");
          this.$refs.confirmPassword.focus();
          return false;
        }
        if (this.userPass != this.confirmPass) {
          alert("Password and confirm password are mismatch");
          this.$refs.confirmPassword.focus();
          return false;
        }
        if (this.isPasswordStrenth == false) {
          alert(
            "Weak password! Password Length Must Be 8 Characters Long.Password Must Have : 1 Digit, 1 Lower Character,1 Upper Character and 1 Special Character."
          );
          return false;
        }
        return true;
      } else {
        if (this.newPassword == null || this.newPassword == "") {
          alert("Please enter your new password");
          return false;
        } else if (
          this.newConfirmPassword == null ||
          this.newConfirmPassword == ""
        ) {
          alert("Please confirm new password");
          return false;
        } else if (this.newPassword != this.newConfirmPassword) {
          alert("Password and confirm password are mismatch");
          return false;
        } else if (this.isPasswordStrenth == false) {
          alert(
            "Weak password! Password Length Must Be 8 Characters Long.Password Must Have : 1 Digit, 1 Lower Character,1 Upper Character and 1 Special Character."
          );
          return false;
        } else if (this.captchaValueforPwd == "") {
          alert("Please enter captcha");
          return false;
        } else {
          return true;
        }
      }
    },
    createNewUser() {
      if (!this.validateInput(1)) {
        return false;
      }
      let pwd = biometricJS.computeHash(this.userPass);
      var createLoginParam = {
        UserID: -1,
        RankID: this.title,
        FName: this.fName,
        MName: this.mName,
        LName: this.lName,
        Gender: this.gender,
        DOB: this.dob.convertToString("dd MMM yyyy"),
        UserMobile: biometricJS.encryptAES(this.userMobile),
        UserEMail: biometricJS.encryptAES(this.userEmail),
        UserPassword: pwd,
        Captchakey: "",
        CaptchaValue: "",
        ConfirmPassword: pwd,
        Type: 1,
        UserType: this.userType,
        ProfileImage: "",
        ProfileImageName: "",
        ProfileImageExtention: "",
        FullAddress: "",
        CompanyName: "",
        CompanyWebSiteName: "",
        CompanyMobile: "",
        CompanyEmail: "",
        CompanyRemarks: "",

        IDType: "",
        IDDocument: ""
      };
      var formData = new FormData();
      formData.append("CreateLoginParam", JSON.stringify(createLoginParam));
      UserManagementJS.createUserOnline(formData).then(
        response => {
          if (response.data.isSuccess) {
            MessageBox.show({
              msg: response.data.msg,
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              msg: response.data.msg,
              type: "error",
              title: "Error"
            });
          }
          this.clearProfile();
        },
        error => {
          if (error.response.data.message != undefined) {
            MessageBox.show({
              msg:
                error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage,
              type: "error",
              title: "Error"
            });
          } else {
            MessageBox.show({
              msg: "Error: " + error.response.data,
              type: "error",
              title: "Error"
            });
          }
        },
        failure => {
          MessageBox.show({
            msg: "Failure: " + failure.response,
            type: "error",
            title: "Error"
          });
        }
      );
    },
    clearProfile() {
      this.userType = -1;
      this.userID = -1;
      this.title = -1;
      this.userType = -1;
      this.gender = 0;
      this.fName = "";
      this.mName = "";
      this.lName = "";
      this.dob = new Date("01 Jan 1900");
      this.userMobile = "";
      this.mob = "";
      this.userEmail = "";
      this.email = "";
      this.fullAdd = "";
      this.userPass = "";
      this.confirmPass = "";
      this.saveProfile = "Save";
      this.companyName = "";
      this.companyWebsite = "";
      this.companyContact = "";
      this.companyEmail = "";
      this.companyComment = "";
      this.isUserAuthenticated = 1;
    },
    changeFilters(filterType) {
      this.rbFilter = filterType;
      this.getUserType();
      this.isUserAuthenticated = 1;
      this.clearProfile();
    },
    checkPasswordStrength(element) {
      this.isPasswordStrenth = false;
      var obj = element.currentTarget;
      var pass = obj.value;
      var lblPasswordStreingth = document.getElementById(
        "lblPasswordStreingth"
      );

      if (lblPasswordStreingth == null) {
        lblPasswordStreingth = document.createElement("div");
        lblPasswordStreingth.id = "lblPasswordStreingth";
        lblPasswordStreingth.style.backgroundColor = "white";
        lblPasswordStreingth.style.fontWeight = "bold";
        lblPasswordStreingth.style.padding = "5px";
        lblPasswordStreingth.style.position = "sticky";
        lblPasswordStreingth.style.left = "350px";
        lblPasswordStreingth.style.whiteSpace = "wrap";
        obj.parentNode.style.position = "relative";
        $(obj).after(lblPasswordStreingth);
      }
      lblPasswordStreingth.style.color = "Red";
      lblPasswordStreingth.style.border = "solid 1px red";
      var msg;
      if (pass.length == 0) {
        lblPasswordStreingth.innerHTML = "";
        lblPasswordStreingth.style.border = "";
        lblPasswordStreingth.style.color = "";
        this.isPasswordStrenth = false;
      } else if (pass.length < 8) {
        msg =
          "Password Length Must Be 8 Characters Long.<br>Password Must Have : 1 Digit, 1 Lower Character,<br>1 Upper Character and 1 Special Character.";
        lblPasswordStreingth.innerHTML = msg;
      } else {
        var variations = {
          digits: /\d/.test(pass),
          lower: /[a-z]/.test(pass),
          upper: /[A-Z]/.test(pass),
          nonWords: /\W/.test(pass)
        };
        msg = "Password Must Have : ";
        if (variations.digits == false) {
          msg += "1 Digit,";
        }
        if (variations.lower == false) {
          msg += "1 Lower Character,";
        }
        if (variations.upper == false) {
          msg += "1 Upper Character,";
        }
        if (variations.nonWords == false) {
          msg += "1 Special Character,";
        }
        lblPasswordStreingth.innerHTML = msg;
        if (
          variations.digits &&
          variations.lower &&
          variations.upper &&
          variations.nonWords
        ) {
          lblPasswordStreingth.innerHTML = "You Have Entered Strong Password";
          lblPasswordStreingth.style.border = "solid 1px green";
          lblPasswordStreingth.style.color = "green";
          this.isPasswordStrenth = true;
        }
      }
    },
    confirmPassword(element) {
      var obj = element.currentTarget;
      var confPass = obj.value;
      var lblConfirmPassword = document.getElementById("lblConfirmPassword");
      if (lblConfirmPassword == null) {
        lblConfirmPassword = document.createElement("div");
        lblConfirmPassword.id = "lblConfirmPassword";
        lblConfirmPassword.style.backgroundColor = "white";
        lblConfirmPassword.style.fontWeight = "bold";
        lblConfirmPassword.style.padding = "5px";
        lblConfirmPassword.style.position = "sticky";
        lblConfirmPassword.style.left = "350px";
        lblConfirmPassword.style.whiteSpace = "wrap";
        obj.parentNode.style.position = "relative";
        $(obj).after(lblConfirmPassword);
      }
      var msg;
      if (confPass.length == 0) {
        lblConfirmPassword.innerHTML = "";
        lblConfirmPassword.style.border = "";
        lblConfirmPassword.style.color = "";
      } else if (confPass.length > 0) {
        if (confPass != this.userPass) {
          msg = "Confirm Password should be same as New Password";
          lblConfirmPassword.style.color = "Red";
          lblConfirmPassword.style.border = "solid 1px red";
          lblConfirmPassword.innerHTML = msg;
        } else if (confPass == this.userPass) {
          lblConfirmPassword.innerHTML = "Password matched";
          lblConfirmPassword.style.border = "solid 1px green";
          lblConfirmPassword.style.color = "green";
        }
      } else {
        lblConfirmPassword.innerHTML = "";
        lblConfirmPassword.style.border = "";
        lblConfirmPassword.style.color = "";
      }
    },
    getUserType() {
      this.isUserAuthenticated = 1;
      this.userType_List = [];
      var type;
      if (this.rbFilter == 2) {
        type = 3;
      } else {
        type = 4;
      }
      const _data_ = { isActive: -1, type: type };
      MasterEntryJS.getUserType(_data_).then(
        response => {
          this.userType_List = response.data;
          if (response.data.length > 0) {
            //console.log(this.userType_List);
          }
        },
        error => {}
      );
    },
    getUserProfile() {
      this.isUserAuthenticated = 1;
      this.userProfile_List = [];
      const _data_ = { userID: this.userID, type: 1 };
      UserManagementJS.getUserProfile(_data_).then(
        response => {
          this.userProfile_List = response.data;
          if (response.data.length > 0) {
            this.fillUserProfile(this.userProfile_List);
            this.user_List.forEach(r => {
              if (r.userID == this.userID) {
                this.userMessage = r.userMessage;
              }
            });
          }
        },
        error => {}
      );
    },
    fillUserProfile(result) {
      //console.log(result);
      this.fName = result[0].fName;
      this.mName = result[0].mName;
      this.lName = result[0].lName;
      this.userType = result[0].userTypeID;
      this.title = result[0].rankID;
      this.dob = result[0].dob;
      this.gender = result[0].gender;
      this.userMobile = result[0].userMobile;
      this.mob = result[0].userMobile;
      this.userEmail = result[0].userEmail;
      this.email = result[0].userEmail;
      this.fullAdd = result[0].fullAddress;
      this.companyName = result[0].companyName;
      this.companyWebsite = result[0].companyWebSiteName;
      this.companyContact = result[0].companyMobile;
      this.companyEmail = result[0].companyEmail;
      this.companyComment = result[0].companyRemarks;
      this.getUserDocData();
      this.getAgentAuth();
      this.UserAuthenticationID = -1;
      this.isUserAuthenticated = result[0].isUserAuthenticated;
      this.ActiveStatus = result[0].isDeleted;
    },
    getUserList() {
      this.isUserAuthenticated = 1;
      this.user_List = [];
      this.authDataList1 = [];
      if (this.isDeleted) {
        this.isDeletedint = 0;
      } else {
        this.isDeletedint = 1;
      }
      if (this.rbFilter == 2) {
        const _data_ = {
          userTypeID: this.userType,
          fromDate: new Date("01 Jan 1900"),
          toDate: new Date("01 Jan 1900"),
          isDeleted: this.isDeletedint,
          type: 2
        };
        UserManagementJS.getUserList(_data_).then(
          response => {
            if (response.data.length > 0) {
              this.user_List = response.data;
            }
            this.userID = -1;
          },
          error => {},
          failure => {}
        );
      }
    },
    getTitle() {
      this.title_List = [];
      const _data_ = { rankID: -1, isActive: 1, type: 1 };
      MasterEntryJS.getRank(_data_).then(
        response => {
          this.title_List = response.data;
          if (response.data.length > 0) {
            //console.log(this.title_List);
          }
        },
        error => {}
      );
    },
    getGenderList() {
      this.gender_List = [];
      const _data_ = { genderID: -1, isActive: 1, type: 1 };
      MasterJS.getGenderList(_data_).then(
        response => {
          if (response.data.length > 0) {
            //console.log(this.gender_List);
            this.gender_List = response.data;
          }
        },
        error => {}
      );
    },
    getUserDocData() {
      this.idType_List = [];
      const _data_ = { userID: this.userID, type: 1 };
      UserManagementJS.getUserDocument(_data_).then(
        response => {
          if (response.data.length > 0) {
            this.idType_List = response.data;
          }
        },
        error => {}
      );
    },
    validateAddress: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      var ok =
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 96 && charCode <= 105) ||
        (charCode >= 97 && charCode <= 122) ||
        charCode == 45 ||
        charCode == 32 ||
        charCode == 44 ||
        charCode == 47;
      if (!ok) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    openScanImage(row) {
      if (row) {
        let imgURL;
        if (imgURL == "") {
          MessageBox.show({
            message: "Image Data Not Found",
            type: "error",
            title: "Error"
          });
        } else {
          var fileExt = row.idImageFileExtension;
          var img = new Image();
          // if (fileExt == "pdf") {
          //   imgURL = "data:application/pdf;base64," + row.idImageFile;
          //   let dom =
          //     "<a href='" +
          //     imgURL +
          //     "' download>" +
          //     row.idImageFileName +
          //     "</a>";
          //   //this.windowPreview.document.write(dom);
          //   let link = document.createElement("a");
          //   link.id = "mylink";
          //   link.href = imgURL;
          //   document.getElementById("mylink").click();
          //   document.removeChild(document.getElementById("mylink"));
          // } else
          {
            this.windowPreview;
            if (this.windowPreview != null) {
              this.windowPreview.close();
            }
            this.windowPreview = window.open(
              "",
              "FilePreview",
              "scrollbars,addressbar=no,location=no,resizable=yes,width=550px,height=600px,left=10,top=10"
            );
            imgURL = "data:image/jpeg;base64," + row.idImageFile;
            img.src = imgURL;
            this.windowPreview.document.write(img.outerHTML);
          }
        }
      }
    },
    openUploadedFile(row) {
      if (row) {
        let imgURL;
        if (imgURL == "") {
          MessageBox.show({
            message: "Image Data Not Found",
            type: "error",
            title: "Error"
          });
        } else {
          var fileExt = row.idImageFileExtension;
          var img = new Image();
          // if (fileExt == "pdf") {
          //   imgURL = "data:application/pdf;base64," + row.idImageFile;
          //   let dom =
          //     "<a href='" +
          //     imgURL +
          //     "' download>" +
          //     row.idImageFileName +
          //     "</a>";
          //   //this.windowPreview.document.write(dom);
          //   let link = document.createElement("a");
          //   link.id = "mylink";
          //   link.href = imgURL;
          //   document.getElementById("mylink").click();
          //   document.removeChild(document.getElementById("mylink"));
          // } else
          {
            this.windowPreview;
            if (this.windowPreview != null) {
              this.windowPreview.close();
            }
            this.windowPreview = window.open(
              "",
              "FilePreview",
              "scrollbars,addressbar=no,location=no,resizable=yes,width=550px,height=600px,left=10,top=10"
            );
            imgURL = "data:image/jpeg;base64," + row.documentFile;
            img.src = imgURL;
            this.windowPreview.document.write(img.outerHTML);
          }
        }
      }
    },
    getEntryType() {
      this.entryType_List = [];
      const _data_ = {};
      UserManagementJS.getEntryType(_data_).then(
        response => {
          if (response.data.length > 0) {
            this.entryType_List = response.data;
          }
        },
        error => {}
      );
    },
    getActiveStatus() {
      this.activeStatus_List = [];
      const _data_ = {};
      MasterJS.getActiveStatus(_data_).then(
        response => {
          if (response.data.length > 0) {
            this.activeStatus_List = response.data;
          }
        },
        error => {}
      );
    },
    editDocAuth(result) {
      this.purpose = result.PurposeExplanation;
      this.add_update = "Update";
    },
    deleteAuthData(result1) {
      this.docAuth_List = [];
      var type = 2;

      var basicData = {
        UserAuthenticationID: result1.userAuthenticationID,
        UserID: -1,
        EntryTypeID: -1,
        ValidFrom: new Date("1900-1-1").convertToString("dd MMM yyyy"),
        ValidTo: new Date("1900-1-1").convertToString("dd MMM yyyy"),
        Comments: "",
        OtherRemarks: "",
        AgentAuthDoc: [],
        IsActive: -1,
        Type: type
      };
      var formData = new FormData();
      formData.append("AuthList", JSON.stringify(basicData));
      if (confirm("Do you want to delete?")) {
        UserManagementJS.saveAgentAuth(formData).then(
          response => {
            if (response.data[0][1]) {
              MessageBox.show({
                message: response.data[0][0],
                type: "success",
                title: "Success"
              });
              this.getAgentAuth();
            } else {
              MessageBox.show({
                message: response.data[0][0],
                type: "error",
                title: "Error"
              });
            }
          },
          error => {}
        );
      }
    },
    editAuthData(result1) {
      this.docAuth_List = [];
      this.UserAuthenticationID = result1.userAuthenticationID;
      this.btnSaveUpdateAuth = "Update Authentication";
      this.entryTypeID = result1.entryTypeID;
      this.fromDate = result1.validDateFrom;
      this.toDate = result1.validDateTo;
      this.comment = result1.comments;
      this.reason = result1.otherRemarks;
      this.activeStatusID = result1.isActive;

      let List = this.authDataList2.filter(item => {
        return item.userAuthenticationID == result1.userAuthenticationID;
      });
      //console.log(List);
      let list1 = [];
      List.forEach(function(item, index) {
        list1.push({
          DocumentTypeID: item.documentTypeID,
          DocumentFile: item.documentFile,
          DocumentFileExtension: item.documentFileExtension,
          DocumentFileName: item.documentFileName,
          PurposeExplanation: item.purposeExplanation
        });
      });
      this.docAuth_List = list1;
    },
    removedocAuth(index) {
      if (confirm("Do you want to delete?")) {
        this.docAuth_List.splice(index, 1);
      }
    },
    addDocAuth() {
      var file = "";
      var fileName = "";
      var fileExt = "";
      this.uploadedFile.forEach(function(item, index) {
        file = item.filePreview;
        fileName = item.docFileName;
        fileExt = item.ext;
      });
      this.docAuth_List.push({
        DocumentTypeID: this.entryTypeID,
        DocumentFile: file,
        DocumentFileExtension: fileExt,
        DocumentFileName: fileName,
        PurposeExplanation: this.purpose
      });
      this.clearDocAuth();
      // console.log(this.document_List);
    },
    clearDocAuth() {
      this.purpose = "";
    },
    FileChosen(evnt) {
      this.getFileData(evnt);
    },
    getFileData(event) {
      var ext = ["PDF", "JPG", "JPEG", "PNG"];
      var me = this;
      var myFiles = [];

      var lstFiles = event.target.files;
      var isValidExtension = true;
      var isValidSize = true;
      var isMinValidSize = true;
      var minCheckSize = parseFloat(10 * 1024);
      var checkSize = parseFloat(50 * 1024);

      for (var i = 0; i < lstFiles.length; i++) {
        var fName = lstFiles[i].name;
        var fileExt = fName.split(".").pop();
        if (!(ext.indexOf(fileExt.toUpperCase()) >= 0)) {
          isValidExtension = false;
        }
        var size = lstFiles[i].size;
        if (parseFloat(size) < minCheckSize) {
          isMinValidSize = false;
        }

        if (parseFloat(size) > checkSize) {
          isValidSize = false;
        }
        myFiles.push(lstFiles[i]);
      }

      if (isValidExtension == false) {
        alert("Unsupported media type.");
        event.target.value = "";
        return false;
      }
      if (isMinValidSize == false) {
        alert(
          "Individual files minimum size should be more than " +
            parseFloat(minCheckSize) / 1024 +
            " KB"
        );
        event.target.value = "";
        return false;
      }
      if (isValidSize == false) {
        alert(
          "Individual files size should be less than " +
            parseFloat(checkSize) / 1024 +
            " KB."
        );
        event.target.value = "";
        return false;
      }
      myFiles.forEach(element => {
        var fName = element.name;
        var fileExt = fName.split(".").pop();
        var reader = new FileReader();
        reader.addEventListener("load", function(e) {
          var object = new Object();
          object.filePreview = e.target.result.split(",")[1];
          object.docFileName = fName;
          object.ext = fileExt;
          me.uploadedFile.push(object);
        });
        if (ext.indexOf(fileExt.toUpperCase()) >= 0) {
          reader.readAsDataURL(element);
        }
      });
    },
    getAgentAuth() {
      this.authDataList1 = [];
      const _data_ = {
        userAuthenticationID: -1,
        userID: this.userID
      };
      UserManagementJS.getAgentAuth(_data_).then(
        response => {
          // console.log(response.data);
          if (response.data.isSuccess) {
            // this.authDataList1 = response.data.result;
            let list1 = [];
            response.data.result1.forEach(function(item, index) {
              list1.push({
                DocumentTypeID: item.documentTypeID,
                DocumentFile: item.documentFile,
                DocumentFileExtension: item.documentFileExtension,
                DocumentFileName: item.documentFileName,
                PurposeExplanation: item.purposeExplanation
              });
            });
            this.docAuth_List = list1;
          }
        },
        error => {},
        failure => {}
      );
    },
    clearAgentAuthentication() {
      this.docAuth_List = [];
      this.UserAuthenticationID = -1;
      this.btnSaveUpdateAuth = "Save Authentication";
      this.entryTypeID = -1;
      this.fromDate = new Date("1900-1-1");
      this.toDate = new Date("1900-1-1");
      this.comment = "";
      this.reason = "";
      this.activeStatusID = 1;
    },
    saveAgentAuthentication() {
      var type = 1;
      var FromDate, ToDate;
      if (this.btnSaveUpdateAuth == "Update Authentication") {
        FromDate = this.fromDate;
        ToDate = this.toDate;
      } else {
        FromDate = this.fromDate.convertToString("dd MMM yyyy");
        ToDate = this.toDate.convertToString("dd MMM yyyy");
      }
      var basicData = {
        UserAuthenticationID: this.UserAuthenticationID,
        UserID: this.userID,
        EntryTypeID: this.entryTypeID,
        ValidFrom: FromDate,
        ValidTo: ToDate,
        Comments: this.comment,
        OtherRemarks: this.reason,
        AgentAuthDoc: this.docAuth_List,
        IsActive: this.activeStatusID,
        Type: type
      };
      var formData = new FormData();
      formData.append("AuthList", JSON.stringify(basicData));
      UserManagementJS.saveAgentAuth(formData).then(
        response => {
          if (response.data[0][1]) {
            MessageBox.show({
              message: response.data[0][0],
              type: "success",
              title: "Success"
            });
            this.getAgentAuth();
            this.clearAgentAuthentication();
          } else {
            MessageBox.show({
              message: response.data[0][0],
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    },
    ClickForApproval(type) {
      if (confirm("Kindly be sure, than click ok for Approval/Disapproval")) {
        let dataForApproval = { UserID: this.userID };
        const _data_ = {
          User_List: [dataForApproval],
          UserTypeID: this.userType,
          Type: type
        };
        var formData = new FormData();
        var Msg = "";
        formData.append("UserList", JSON.stringify(_data_));
        UserManagementJS.manageUserAuth(formData).then(
          response => {
            if (type == 1) {
              Msg = "User approved successfully.";
            } else if (type == 2) {
              Msg = "User disapproved successfully.";
            }
            if (response.data.isSuccess) {
              this.getUserProfile();
              MessageBox.show({
                message: Msg,
                type: "success",
                title: "Success"
              });
            } else {
              MessageBox.show({
                message: Msg,
                type: "error",
                title: "Error"
              });
            }
          },
          error => {},
          failure => {}
        );
      }
    },
    ClickForActiveInactive(type) {
      var document_List1 = [];
      var document_List2 = [];
      var basicData = {
        UserID: this.userID,
        UserTypeID: this.userType,
        RankID: -1,
        FName: "",
        MName: "",
        LName: "",
        DOB: new Date("1900-1-1").convertToString("dd MMM yyyy"),
        Gender: "",
        UserMobile: "",
        UserEmail: "",
        UserPassword: "",
        IDType: -1,
        FullAddress: "",
        ProfileImage: "",
        ProfileImageName: "",
        ProfileImageExtention: "",
        UserPassword: "",
        CompanyName: "",
        CompanyWebsiteName: "",
        companyMobile: "",
        CompanyEmail: "",
        CompanyRemarks: "",

        IDType: document_List1,
        IDDocument: document_List2,
        Type: type
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      UserProfile.updateUserProfile(formData).then(
        response => {
          console.log(response);
          var msg = response.data[0][0];
          var isSuccess = response.data[0][1];
          if (isSuccess == 1) {
            this.getUserProfile();
            this.getUserList();
          } else {
            MessageBox.show({
              message: msg,
              type: "error",
              title: "Error"
            });
          }
        },
        error => {
          MessageBox.show({
            message: "Something went wrong, Please try again...",
            type: "error",
            title: "Error"
          });
        }
      );
    }
  },
  mounted() {
    this.getUserType();
    this.getTitle();
    this.getGenderList();
    this.getEntryType();
    this.getActiveStatus();
  }
};
</script>

<style scoped>
.wrapText {
  overflow-wrap: anywhere;
}
#background {
  background: url("../assets/images/logoa.png");
}
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divSummary {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
        border-radius: 5px;
        padding: 5px 0px 0px 5px; */
}
.ekkGrid > .Flex_Row:hover:not(.GridHeader),
.ekkGrid > .GridContent > .Flex_Row:hover:not(.GridHeader) {
  background-color: #ffa50069;
  color: black;
}
</style>
<style scoped>
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style scoped>
.rblDiv {
  display: inline;
  margin-right: 5%;
}
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  border: solid 1px;
  border-radius: 4px;
  top: 110px;
  position: absolute;
  min-height: 256px;
  right: 380px;
  /* background-color: ;rgba(255, 248, 248, 0.86); */
  background-color: ghostwhite;
  -webkit-box-shadow: 1px 1px 20px 1px white;
  box-shadow: 1px 1px 20px 1px white;
  border-radius: 8px 8px 8px 8px;
  z-index: 2;
  color: black !important;
  width: 600px;
}
.PopUpDetail {
  padding: 10px;
  /* min-height: 200px;
        max-height: 400px; */
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 38px;
  border-bottom: solid 1px;
  border-radius: 8px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px; */
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px black; */
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .docGrid {
    width: 50% !important;
  }
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .docGrid {
    width: 100% !important;
  }
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CreateUser.vue